import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import extend from 'lodash/extend';
import Sticky from 'react-stickynode';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import matchMediaDesktop from '../../../../utils/client_util';
import loadData from './wp_page_state_manager';
import MICApplyCarousel from './mic_apply_carousel';

class WP extends Component {
  static loadData(store) {
    return loadData(store);
  }

  componentDidMount() {
    this.isDesktop = matchMediaDesktop();
    this.openAccordion = null;
  }

  render() {
    const { wpPage, customPage } = this.props;

    if (wpPage.error && customPage.error) {
      return (
        <section className="wp-page">
          <article className="wp-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (wpPage.isLoading) {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const adData = get(wpPage, 'ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );
    const content = get(customPage, 'content.rendered');

    const singleColLayout = [
      'about',
      'most-innovative-companies',
      'world-changing-ideas',
      'innovation-by-design',
      'best-workplaces-for-innovators',
      'opt-out',
      'brands-that-matter',
      'next-big-things-in-tech'
    ];

    const lists = ['testing-a-new-page'];

    // This conditional is for non-standard custom WP Page layouts like franchise awards pages.
    const slug = get(customPage, 'slug');
    const lookup = {
      about: {
        modifier: 'ibd',
        img:
          'https://images.fastcompany.net/image/upload/w_700,h_400,c_crop,q_auto:best,f_auto,fl_lossy/v1500314681/fcweb/3056495-poster-ibd-logo-poster-thin_qmvllz.jpg',
        mobile_img: null,
        link: null
      },
      'most-innovative-companies': {
        modifier: 'mic',
        img:
          'https://images.fastcompany.net/image/upload/v1531847322/fcweb/FastCo-MIC-Logos_large-logo-2-color-inverse-400_xxxudx.png',
        mobile_img: null,
        link:
          'https://fastcompany-mic.secure-platform.com/a/solicitations/home/4',
        alt: '2019 Most Innovative Companies',
        tracker: `
          <script async src="https://www.googletagmanager.com/gtag/js?id=UA-80768042-2"></script>
          <script>
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'UA-80768042-2', {
              'linker': {
                'domains': ['fastcompany.com', 'fastcompany.swoogo.com']
              }
            });
          </script>
        `
      },
      'world-changing-ideas': {
        modifier: 'wci',
        img:
          'https://images.fastcompany.net/image/upload/v1543249244/fc/wci.web.homepage_eqpqrv.jpg',
        mobile_img:
          'https://images.fastcompany.net/image/upload/v1543361034/fcweb/vpKK-cpg_iojbhq.jpg',
        link: null,
        alt: 'World Changing Ideas',
        tracker: `
        <script async src="https://www.googletagmanager.com/gtag/js?id=UA-80768042-3"></script>
        <script>
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'UA-80768042-3', {
            'linker': {
              'domains': ['fastcompany.com', 'fastcompany.secure-platform.com']
            }
          });
        </script>
        `
      },
      'innovation-by-design': {
        modifier: 'ibd',
        img:
          'https://assets.fastcompany.com/image/upload/v1551903384/IBD%202019/1a-2019-ibd-header.jpg',
        mobile_img: null,
        link: null,
        alt: 'Innovation By Design Awards',
        tracker: null
      },
      'best-workplaces-for-innovators': {
        modifier: 'bwi',
        img:
          'https://images.fastcompany.net/image/upload/v1550789055/fcweb/TdSA0B2M_iezcoc.png',
        mobile_img: null,
        link: null,
        alt: 'Best Workplaces for Innovators',
        tracker: null
      },
      'opt-out': {
        modifier: 'cookie',
        img: null,
        mobile_img: null,
        link: null,
        alt: 'Opt Out',
        tracker: null
      },
      'testing-a-new-page': {
        modifier: 'tanp',
        img:
          'https://images.fastcompany.net/image/upload/v1583252048/fc/q50-hero-img_vgcfaz.svg',
        mobile_img: null,
        link: null,
        alt: 'T.A.N.P.',
        dek:
          'Our tkers list of the tksmartest non-binary tkers goes here tktktk',
        tracker: null
      },
      'brands-that-matter': {
        modifier: 'btm',
        img:
          'https://images.fastcompany.net/image/upload/v1611786893/fcweb/BTM_Knockout_w9wevd.svg',
        mobile_img: null,
        link:
          'https://fastcompany-btm.secure-platform.com/a/solicitations/15/home',
        alt: 'Brands that Matter'
      },
      'next-big-things-in-tech': {
        modifier: 'nbtit',
        img:
          'https://images.fastcompany.net/image/upload/v1614635362/fcweb/fc-nbtit-logo-for-color-bg_rjzdik.svg',
        mobile_img: null,
        link:
          'https://fastcompany-nbt.secure-platform.com/a/solicitations/17/home',
        alt: 'Next Big Thing In Tech'
      }
    };

    const header = lookup[slug] || null;
    const hasMobileImage = !isEmpty(header) && !isEmpty(header.mobile_img);

    // List style pages...
    if (customPage.error) {
      return <div>Bigly error.</div>;
    }

    if (lists.indexOf(get(customPage, 'slug')) > -1) {
      const listData = content.split('<hr />');

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < listData.length; i++) {
        listData[i] = listData[i]
          .replace(/<p>/gm, '')
          .replace(/<\/p>/gm, '<!-- SPLIT -->')
          .split('<!-- SPLIT -->');
        listData[i] =
          listData[i].length > 6 ? (listData[i].length = 6) : listData[i];
        listData[i].splice(listData[i].length - 1, 1);

        // IMAGE
        const imgUrlData = listData[i][0].match(/src="\S+"/);
        const imgUrl = imgUrlData[0].replace('src="', '').replace('"', '');
        listData[
          i
        ][0] = `<div class="image" style="background-image: url(${imgUrl})"></div>`;

        // LINK
        if (listData[i][4]) {
          const linkUrlData = listData[i][4].match(/href="\S+"/);
          const linkUrl = linkUrlData[0].replace('href="', '').replace('"', '');
          listData[i][4] = linkUrl;
        }
      }

      return (
        <section className={`list-page ${get(customPage, 'slug')}`}>
          <div className="header">
            <div className="hero">
              <img
                src={get(header, 'img')}
                alt={get(customPage, 'title.rendered')}
              />
            </div>
            <h2 className="deck">{get(header, 'dek')}</h2>
          </div>

          <div className="post">
            <div className="post__main">
              <article className="post__article">
                {listData.map((entry, idx) => (
                  <div className="list-entry" key={`list-entry-${idx}`}>
                    <div
                      className="col-l"
                      dangerouslySetInnerHTML={{ __html: entry[0] }}
                    />
                    <div className="col-r">
                      <div className="above-accordion">
                        <div
                          className="entry-count"
                          dangerouslySetInnerHTML={{
                            __html: idx < 10 ? `0${idx + 1}` : idx + 1
                          }}
                        />
                        <div
                          className="entry-name"
                          dangerouslySetInnerHTML={{ __html: entry[1] }}
                        />
                        <div
                          className="entry-deck"
                          dangerouslySetInnerHTML={{ __html: entry[2] }}
                        />
                        <button
                          onClick={() => {
                            this.openAccordion =
                              this.openAccordion === idx ? null : idx;
                            this.forceUpdate();
                          }}
                        >
                          +
                        </button>
                      </div>

                      <div
                        className={`entry-accordion ${
                          this.openAccordion === idx ? 'open' : 'closed'
                        }`}
                      >
                        <div
                          className="entry-copy"
                          dangerouslySetInnerHTML={{ __html: entry[3] }}
                        />
                        {entry[4] && (
                          <a
                            className="entry-button"
                            href={entry[4]}
                            target="_blank"
                          >
                            MORE
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </article>
            </div>

            <div className="post__sidebar" id="custom-page-ad">
              {get(content, 'length') ? (
                <Sticky
                  top={100}
                  bottomBoundary="#custom-page-ad"
                  enabled={this.isDesktop}
                >
                  <Ad
                    {...combinedAdModel}
                    noLazyLoad={true}
                    pos="atf"
                    name="flexiblehalfpage"
                  />
                </Sticky>
              ) : (
                ''
              )}
            </div>
          </div>
        </section>
      );
    }

    // Single column layout pages...
    if (singleColLayout.indexOf(get(customPage, 'slug')) > -1) {
      return (
        <section className="awards-page">
          {header ? (
            <header
              className={`awards-page__header awards-page__header--${
                header.modifier
              }`}
            >
              <a href={header.link} title={header.alt}>
                {header.img && (
                  <img
                    className={`page__header--desktop-image ${
                      hasMobileImage ? 'hide-on-mobile' : ''
                    }`}
                    src={header.img}
                    alt={header.alt}
                  />
                )}
                {hasMobileImage && (
                  <img
                    className={`page__header--mobile-image ${
                      hasMobileImage ? 'hide-on-desktop' : ''
                    }`}
                    src={header.mobile_img}
                    alt={header.alt}
                  />
                )}
              </a>
            </header>
          ) : (
            ''
          )}

          {header.alt === '2019 Most Innovative Companies' ? (
            <section className="awards-page__content">
              <div className="awards-page__main">
                <article dangerouslySetInnerHTML={{ __html: content }} />
                <h2 className="awards-page__heading awards-page__heading--mic">
                  <span className="awards-page__heading-text">
                    Past Winners
                  </span>
                </h2>
              </div>

              <MICApplyCarousel />

              <h2 className="awards-page__photo-credit">
                Most Innovative Companies logo by Peter Komierowski
              </h2>
            </section>
          ) : (
            <div className="awards-page__main">
              <article dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          )}

          {header && !isEmpty(header.tracker) ? (
            <div dangerouslySetInnerHTML={{ __html: header.tracker }} />
          ) : (
            ''
          )}
        </section>
      );
    }

    return (
      <section className="custom-page">
        <div className="post_wrapper">
          <section className="custom-content">
            <div className="post">
              <div className="post__main">
                <h1 className="post__title">
                  {get(customPage, 'title.rendered')}
                </h1>
                <article
                  className="post__article"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              </div>
              <div className="post__sidebar" id="custom-page-ad">
                {get(content, 'length') ? (
                  <Sticky
                    top={100}
                    bottomBoundary="#custom-page-ad"
                    enabled={this.isDesktop}
                  >
                    <Ad
                      {...combinedAdModel}
                      noLazyLoad={true}
                      pos="atf"
                      name="flexiblehalfpage"
                    />
                  </Sticky>
                ) : (
                  ''
                )}
              </div>
            </div>
          </section>
        </div>
        <section className="recirc-feed">
          {!isEmpty(customPage) ? (
            <div>
              <Ad
                {...combinedAdModel}
                name="flexiblebillboard_1"
                noLazyLoad={true}
              />
              <Ad
                {...combinedAdModel}
                name="mobileparallax_1"
                noLazyLoad={true}
              />
            </div>
          ) : (
            ''
          )}
        </section>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    wpPage: state.wpPage || {
      ads: {
        baseConfig: {}
      }
    },
    customPage: get(state, 'customPage.data.page[0]') || { error: true }
  };
}

WP.propTypes = {
  wpPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  customPage: PropTypes.shape({
    error: PropTypes.bool
  }).isRequired
};

export default connect(mapStateToProps)(WP);
